import React from 'react';
import './styles.scss';
import { Box, Paper, Typography } from '@mui/material';
import { SupportAgent } from '@mui/icons-material';

export interface IBottomLiveBarProps {
}

export const BottomLiveBar: React.FunctionComponent<IBottomLiveBarProps> = (props) => {  
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Paper elevation={0} sx={{ padding: '8px 10px', display: 'flex', alignItems: 'center', gap: '10px' }}>
        <SupportAgent color="primary" />
        <Typography variant="body1" color="secondary.main" fontWeight="bold">
          Live Assistance 
        </Typography>
        <a href="tel:1-877-664-6669">
          <Typography variant="body1" color="primary.main">
            1-877-664-6669 
          </Typography>
        </a>
      </Paper>
    </Box>
  );
};

export default BottomLiveBar;
